// console.log(Shopify.translation)
// console.log(Shopify.theme_settings)

Shopify.theme.jsSlideshow = {
  init: function($section){
    console.log('slideshow');
    this.createSlideshow($section);
  },
  createSlideshow: function($section){
    $('h2', $section).hide();
  }
}

Shopify.theme.reviews = {
  init: function() {
    if ($('#shopify-product-reviews').length || $('.shopify-product-reviews-badge').length) {
      SPR.$(document).ready(function () {
        return SPR.registerCallbacks(),
          SPR.initRatingHandler(),
          SPR.initDomEls(),
          SPR.loadProducts(),
          SPR.loadBadges()
      })
    }
  }
}

Shopify.theme.animation = {
  init: function(){
    $('[data-scroll-class]').waypoint(function() {
      const animationClass = $(this.element).data('scroll-class');
      $(this.element).addClass('animated').addClass(animationClass);
    }, { offset: '70%' });
  },
  unload: function($target){
    $target.data('scroll-class', '');
  }
}

// Section Shopify Shopify.theme editor events

$(document)
.on('shopify:section:reorder', function(e){

  const $target = $(e.target);
  const $parentSection = $('#shopify-section-' + e.detail.sectionId);

  if (Shopify.theme.jsHeader.enable_overlay == true) {
    Shopify.theme.jsHeader.unload();
    Shopify.theme.jsHeader.updateOverlayStyle(Shopify.theme.jsHeader.sectionUnderlayIsImage());
  }

});

$(document)
.on('shopify:section:load', function(e){

  // Shopify section as jQuery object
  const $section = $(e.target);

  // Vanilla js selection of Shopify section
  const section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Blocks within section
  const $jsSectionBlocks = $section.find('.shopify-section[class*=js]');

  // Check classes on schema and look for js (eg. jsSlideshow)
  for (let i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js"){
      const triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass]) {
        console.log(`Section: ${triggerClass} has been loaded.`)
        Shopify.theme[triggerClass].init($(section));
      } else {
        console.warn(`Uh oh, ${triggerClass} is referenced in section schema class, but can not be found. Make sure "z__${triggerClass}.js" and Shopify.theme.${triggerClass}.init() function exists.`);
      }
    }
  }

  // Check classes on block element and look for js (eg. jsSlideshow)
  if ($jsSectionBlocks.length > 0) {
    const $jsSectionBlockNames = $jsSectionBlocks.each(function () {
      for (let i = 0; i < this.classList.length; i++) {
        if (this.classList[i].substring(0, 2) === "js") {
          let triggerClass = this.classList[i];
          if (Shopify.theme[triggerClass]) {
            console.log(`Block: ${triggerClass} has been loaded.`)
            Shopify.theme[triggerClass].init($(this));
          } else {
            console.warn(`Uh oh, ${triggerClass} is referenced in block class, but can not be found. Make sure "z__${triggerClass}.js" and Shopify.theme.${triggerClass}.init() function exists.`);
          }

        }
      }
    });
  }

  // Scrolling animations
  Shopify.theme.animation.init();

  //Initialize reviews
  Shopify.theme.reviews.init();

});


$(document)
.on('shopify:section:unload', function(e){

  // Shopify section as jQuery object
  const $section = $(e.target);

  // Vanilla js selection of Shopify section
  const section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Blocks within section
  const $jsSectionBlocks = $section.find('.shopify-section[class*=js]');

  // Check classes on schema and look for js (eg. jsSlideshow)
  for (let i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js"){
      const triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass]) {
        console.log(`Section: ${triggerClass} is unloaded.`)
        Shopify.theme[triggerClass].unload($(section));
      } else {
        console.warn(`Uh oh, ${triggerClass} is referenced in section schema class, but can not be found. Make sure "z__${triggerClass}.js" and Shopify.theme.${triggerClass}.unload() function exists.`);
      }
    }
  }

  // Check classes on block element and look for js (eg. jsSlideshow)
  if ($jsSectionBlocks.length > 0) {
    const $jsSectionBlockNames = $jsSectionBlocks.each(function () {
      for (let i = 0; i < this.classList.length; i++) {
        if (this.classList[i].substring(0, 2) === "js") {
          let triggerClass = this.classList[i];
          if (Shopify.theme[triggerClass]) {
            console.log(`Block: ${triggerClass} is unloaded.`)
            Shopify.theme[triggerClass].unload($(this));
          } else {
            console.warn(`Uh oh, ${triggerClass} is referenced in block class, but can not be found. Make sure "z__${triggerClass}.js" and Shopify.theme.${triggerClass}.unload() function exists.`);
          }

        }
      }
    });
  }

  // Scrolling animations
  Shopify.theme.animation.unload($section);

});

$(document)
.on('shopify:section:select', function(e){

  // Shopify section as jQuery object
  const $section = $(e.target);

  // Vanilla js selection of Shopify section
  const section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Force show state when section is selected in theme editor
  for (let i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js") {
      const triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass].showThemeEditorState) {
        Shopify.theme[triggerClass].showThemeEditorState(e.detail.sectionId, $section);
      }
    }
  }

});

$(document)
.on('shopify:section:deselect', function(e){

  // Shopify section as jQuery object
  const $section = $(e.target);

  // Vanilla js selection of Shopify section
  const section = document.getElementById('shopify-section-' + e.detail.sectionId);

  // Force hide state when section is selected in theme editor
  for (let i = 0; i < section.classList.length; i++) {
    if (section.classList[i].substring(0, 2) === "js") {
      const triggerClass = section.classList[i];
      if (Shopify.theme[triggerClass].showThemeEditorState) {
        Shopify.theme[triggerClass].hideThemeEditorState(e.detail.sectionId, $(section));
      }
    }
  }

});

// Block Shopify Shopify.theme editor events

$(document)
.on('shopify:block:select', function(e){

  // Scrolling animations
  Shopify.theme.animation.init();

});

$(document)
.on('shopify:block:deselect', function(e){

  const $target = $(e.target);
  const blockId = e.detail.blockId;
  const $parentSection = $('#shopify-section-' + e.detail.blockId);

});

$(document)
.on('shopify:block:load', function(e){



});

// Document ready
$(function() {

  const $jsSections = $('.shopify-section[class*=js]');

  // Loop through sections with js classes and load them in
  const $jsSectionNames = $jsSections.each(function () {
    for (let i = 0; i < this.classList.length; i++) {
      if (this.classList[i].substring(0, 2) === "js"){
        let triggerClass = this.classList[i];
        if (Shopify.theme[triggerClass]) {
          console.log(`Section: ${triggerClass} has been loaded.`)
          Shopify.theme[triggerClass].init($(this));
        } else {
          console.warn(`Uh oh, ${triggerClass} is referenced in section schema class, but can not be found. Make sure "z__${triggerClass}.js" and Shopify.theme.${triggerClass}.init() function exists.`);
        }

      }
    }
  });

  // Scrolling animations
  Shopify.theme.animation.init();

});

/*============================================================================
Start of cart-related functionality
==============================================================================*/

function ajaxSubmitCart(cart) {
  $cart = cart;
  $.ajax({
    url: '/cart/update.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: $cart.serialize(),
    success: function (data) {
      refreshCart(data);
    }
  });
}

function ajaxUpdateCart(lineID, quantity, parent) {
  $.ajax({
    url: '/cart/change.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: { quantity: quantity, line: lineID },
    success: function (data) {
      refreshCart(data);

      var lineIDIndex = lineID - 1;

      //check to see if there are correct amount of products in array
      if (typeof data.items[lineIDIndex] === "undefined") {
        var updated_quantity = 0;
      } else {
        var updated_quantity = data.items[lineIDIndex].quantity;
      }

      if (quantity > 0 && quantity != updated_quantity) {
        if (updated_quantity == 1) {
          items_left_text = Shopify.translation.product_count_one;
        } else {
          items_left_text = Shopify.translation.product_count_other;
        }

        $('.warning--quantity').remove();

        var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
        parent.find("input[data-line-id='" + lineID + "']").parent().after(warning);
        parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);

      } else if (parent.is('#cart_form')) {
        $("#cart_form").submit();
      }
    }
  });
}

//Used for cart functionality
function htmlEncode(value) {
  if (value) {
    return $('<div/>').text(value).html();
  } else {
    return '';
  }
}

// function refreshCart(cart) {
//   $(".cart_count").empty();
//   $cartBtn = $(".cart_count");
//   var value = $cartBtn.text() || '0';
//   var cart_items_html = "";
//   var cart_action_html = "";
//   var cart_savings_html = "";
//   var $cart = $(".cart_content form");
//   var discounted_price_total = 0;
//   var total_savings = 0;

//   $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));

//   if (cart.item_count == 0) {
//     $('.js-empty-cart__message').removeClass('hidden');
//     $('.js-cart_content__form').addClass('hidden');
//   } else {
//     $('.js-empty-cart__message').addClass('hidden');
//     $('.js-cart_content__form').removeClass('hidden');

//     $.each(cart.items, function (index, item) {
//       var line_id = index + 1;
//       cart_items_html += '<li class="cart_item clearfix">' +
//       '<a href="' + item.url + '">';
//       if (item.image) {
//         cart_items_html += '<div class="cart_image">' +
//         '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
//         '</div>';
//       }

//       cart_items_html += '<div class="cart_item__title"><div class="item_title">' + item.title;

//       if (item.properties) {
//         $.each(item.properties, function (title, value) {
//           if (value) {
//             cart_items_html += '<div class="line-item">' + title + ': ' + value + '</div>';
//           }
//         });
//       }
//       cart_items_html += '</div></a>';

//       cart_items_html += '<div class="left product-quantity-box">' +
//       '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>' +
//       '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity + '" data-line-id="' + line_id + '" />' +
//       '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' +
//       '</div>' +
//       '</div>';

//       cart_items_html += '<strong class="right price">';

//       
//       $.ajax({
//         dataType: "json",
//         async: false,
//         cache: false,
//         url: "/products/" + item.handle + ".js",
//         success: function (data) {
//           var variant_id = item.variant_id;
//           var variant = $.grep(data.variants, function (v) {
//             return v.id == variant_id;
//           });

//           if (variant[0] && variant[0].compare_at_price > item.price) {
//             cart_items_html += ' <span class="money was-price">' + Shopify.formatMoney(variant[0].compare_at_price, $('body').data('money-format')) + '</span> ';
//             discounted_price_total += item.price * item.quantity;
//             total_savings += variant[0].compare_at_price * item.quantity;
//           }
//         }
//       });
//       

//       cart_items_html += '<span class="money">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span></strong>' + '</div>';

//     });

//     cart_action_html += '<span class="right"><span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span></span>' +
//     '<span>Subtotal</span>';

//     if (total_savings > 0) {
//       cart_savings_html = '<span class="right"><span class="money">' + Shopify.formatMoney(total_savings - discounted_price_total, $('body').data('money-format')) + '</span></span>' +
//       '<span>Total Savings</span>';
//     } else {
//       cart_savings_html = "";
//     }
//   }

//   $('.js-cart_items').html(cart_items_html);
//   $('.js-cart_subtotal').html(cart_action_html);
//   $('.js-cart_savings').html(cart_savings_html);

//   
// }

$('body').on("change", "#cart_form input.quantity", function () {
  ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart_form'));
});

$('body').on("change", ".cart_content input.quantity", function () {
  ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('.cart_content'));
});


$(document).on('click', '.ajax-submit', function (e) {
  e.preventDefault();
  var $addToCartForm = $(this).closest('form');
  var $addToCartBtn = $addToCartForm.find('.add_to_cart');

  $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: $addToCartForm.serialize(),
    beforeSend: function () {
      $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
      $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
    },
    success: function (itemData) {
      $addToCartBtn.find('.checkmark').addClass('checkmark-active');

      window.setTimeout(function () {
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
        $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
      }, 1000);

      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        success: function (cart) {
          refreshCart(cart);
          if ($('body').hasClass('fancybox-active')) {
            $.fancybox.close();
          }

          if ($('#header').is(':visible')) {
            $('#header .cart_container').addClass('active_link');
          } else if ($('.sticky_nav--stick').length) {
            $('.sticky_nav .cart_container').addClass('active_link');
          } else {
            $('.top_bar .cart_container').addClass('active_link');
          }

          //block scrolling on mobile
          if ($(window).width() <= 798) {
            var $cart_container = $(this).parent();
            if ($cart_container.hasClass('active_link')) {
              $('body').addClass('blocked-scroll');
            } else {
              $('body').addClass('blocked-scroll');
            }
          }
        }
      });
    },
    error: function (XMLHttpRequest) {
      var response = eval('(' + XMLHttpRequest.responseText + ')');
      response = response.description;
      $('.warning').remove();

      var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
      $addToCartForm.after(warning);
      $addToCartBtn.removeAttr('disabled').removeClass('disabled');
      $addToCartBtn.find('span').text(Shopify.translation.addToCart).removeClass('zoomOut').addClass('zoomIn');
    }
  });

  return false;
});




